import React from "react";

export const AER_PHRASE = "Accelerated Emergency Response";

/** Inline brand mark for “Accelerated Emergency Response” */
const AerMark = ({ className = "" }) => (
  <span className={`sv-aer ${className}`.trim()}>{AER_PHRASE}</span>
);

/**
 * Wrap every occurrence of AER_PHRASE in a string with .sv-aer.
 * Returns the original string when the phrase is absent.
 */
export const highlightAer = (text) => {
  if (typeof text !== "string" || !text.includes(AER_PHRASE)) {
    return text;
  }

  const parts = text.split(AER_PHRASE);
  return parts.reduce((nodes, part, i) => {
    if (i === 0) {
      return part ? [part] : [];
    }
    return [
      ...nodes,
      <AerMark key={`aer-${i}`} />,
      ...(part ? [part] : []),
    ];
  }, []);
};

export default AerMark;
